import type {
  WhatsAppSender,
  WhatsAppSenderCatalog,
  WhatsAppTemplate,
} from "../types";

export type WhatsAppSenderPurpose = "direct" | "marketing";

export function senderCanSend(
  sender: WhatsAppSender,
  purpose: WhatsAppSenderPurpose,
): boolean {
  if (sender.lifecycle !== "ready") return false;
  return purpose === "marketing" ? sender.allow_marketing : true;
}

export function selectableSenders(
  catalog: WhatsAppSenderCatalog | null,
  purpose: WhatsAppSenderPurpose,
): WhatsAppSender[] {
  return (catalog?.senders ?? []).filter((sender) =>
    senderCanSend(sender, purpose),
  );
}

export function initialSenderKey(
  catalog: WhatsAppSenderCatalog,
  purpose: WhatsAppSenderPurpose,
): string {
  const available = selectableSenders(catalog, purpose);
  if (
    available.some((sender) => sender.sender_key === catalog.default_sender_key)
  ) {
    return catalog.default_sender_key;
  }
  return available[0]?.sender_key ?? "";
}

export function senderLabel(sender: WhatsAppSender): string {
  const number = sender.public_e164 ? ` · ${sender.public_e164}` : "";
  return `${sender.display_name}${number}`;
}

export function templateMatchesSender(
  template: WhatsAppTemplate,
  sender: WhatsAppSender | undefined,
): boolean {
  if (!sender) return false;
  const templateAccountId = template.provider_waba_id || template.waba_id;
  if (!templateAccountId) return true;
  return templateAccountId === sender.template_account_id;
}
